import cn from 'classnames';
import styles from './styles.module.scss';

const Row = ({ spaceBetween = false, center = false, right = false, wrap = false, children, className, ...props }) => (
  <div
    {...props}
    className={cn(
      styles.row,
      center && styles.center,
      right && styles.right,
      spaceBetween && styles.row_between,
      wrap && styles.row_wrap,
      className,
      props.styles,
    )}
    style={props.style}
    {...props}
  >
    {children}
  </div>
);

export default Row;
